'use client';

import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import sample from 'lodash/sample';
import MainSearch from './MainSearch';
import { HotJobTitlesType } from '@/components/home-page';
import { JobOptionType } from '@/components/job-title/search-area/JobTitleSearch';
import { JOB_TITLE_PAGE_ROUTER_PATH } from '@/constants/router-path';
import { HOME_PAGE_SEARCH_INPUT_ID } from '@/constants/component-id';
import { BASE_HEADER_HEIGHT } from '@/constants/profile-builder';
import { trackClickEvent } from '@/utils/site-track';
import MainSearchImage from '@/assets/resume-marketing/main-search.png';

export const OFFSET_PIXELS = -42 - BASE_HEADER_HEIGHT; //header height and input height

const SearchArea = (props: {
  hotJobTitles: HotJobTitlesType;
  className?: string;
}) => {
  const { hotJobTitles, className = 'my-20 tablet:my-25' } = props;

  const [value, setValue] = React.useState<JobOptionType>({
    id: '',
    name: '',
    nameType: '',
    aliasId: '',
  });
  const [recommendOptions, setRecommendOptions] = React.useState<any[]>([]);

  React.useEffect(() => {
    if (hotJobTitles && hotJobTitles.length) {
      setRecommendOptions(
        hotJobTitles.map((item) => sample(item.job_titles)).filter(Boolean),
      );
    }
  }, []);

  return (
    <div
      className={`pt-16 pb-[87px] [background:linear-gradient(90deg,#cdcfff_0%,#ffffff_81.5%),linear-gradient(180deg,rgba(255,255,255,0)_0%,rgba(255,255,255,0.6)_100%)] ${className} tablet:pt-32 tablet:pb-32`}
    >
      <div className="mx-auto px-5 tablet:max-w-[1200px]">
        <div className="flex flex-col tablet:justify-between tablet:flex-row">
          <div className="w-full tablet:w-[698px]">
            <h1 className="text-3.25xl font-semibold line-clamp-2 mb-4 tablet:text-4.5xl">
              搜索感兴趣的职业薪酬·公司
            </h1>
            <p className="mb-10 w-full text-xl tablet:w-[590px]">
              我们提供基于大数据的职场数据，包括薪资、职场职位数，城市收入等，为你的职位选择提供助力
            </p>
            <MainSearch
              id={HOME_PAGE_SEARCH_INPUT_ID}
              value={value}
              onChange={(newValue) => setValue(newValue)}
              autoClassName="!w-full !shadow-none tablet:!flex-1 tablet:!rounded-full tablet:!overflow-hidden tablet:!shadow-[0px_5px_10px_rgba(0,0,0,0.12)]"
              className="mt-8"
              paperClassName="!bg-transparent !border-b !border-black !rounded-none !py-3.5 tablet:!px-4 tablet:!bg-white tablet:!border-none"
              inputClassName="!text-base"
              mountedSearch={true}
              multiSearch={true}
            >
              <div className="mt-10 tablet:h-10">
                {recommendOptions.length > 0 && (
                  <div className="flex text-sm font-semibold tablet:text-base">
                    <span className="mr-2 flex-shrink-0 leading-[2.375rem] tablet:leading-10">
                      热门职位
                    </span>
                    <div className="flex gap-x-2 gap-y-3.5 flex-wrap">
                      {recommendOptions.slice(0, 4).map((item) => (
                        <React.Fragment key={item.id}>
                          {item && (
                            <Link
                              className="px-3 py-2 rounded-full overflow-hidden bg-white hover:shadow-md tablet:px-4"
                              href={`${JOB_TITLE_PAGE_ROUTER_PATH}${item.id}/`}
                              data-ele-group="search_job-title_recommend"
                              data-ele-id={`${item.id}_${item.name}`}
                              onClick={(e) => trackClickEvent(e, true)}
                            >
                              {item.name}
                            </Link>
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </MainSearch>
          </div>
          <div className="w-full mt-16 tablet:max-w-[343px] tablet:mt-9.5">
            <Image
              src={MainSearchImage}
              alt=""
              style={{
                objectFit: 'contain',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchArea;
